import {
  EARNINGS_DATA_TIMEZONE,
  TIME_FILTER_OPTIONS,
  TTimeFilterType,
} from "../../../../constants";
import moment from "moment-timezone";
import getWeekLabel from "../../utils/getWeekLabel";
import { useMemo } from "react";
import { MOMENT_GRANULARITIES } from "../../constants";
import styles from "./styles.module.scss";
import getClasses from "utils/getClasses";

type Props = {
  x: number;
  y: number;
  payload: {
    value: number;
  };
  filterType: TTimeFilterType;
};

const CustomXAxisTick = ({ x, y, payload, filterType }: Props) => {
  const { isFuture, isCurr } = useMemo(() => {
    const nowMoment = moment().tz(EARNINGS_DATA_TIMEZONE);

    return {
      isFuture: moment
        .tz(payload.value, EARNINGS_DATA_TIMEZONE)
        .isAfter(nowMoment.clone(), MOMENT_GRANULARITIES[filterType]),
      isCurr: moment
        .tz(payload.value, EARNINGS_DATA_TIMEZONE)
        .isSame(nowMoment.clone(), MOMENT_GRANULARITIES[filterType]),
    };
  }, [filterType, payload.value]);

  const label = useMemo(
    () =>
      filterType === TIME_FILTER_OPTIONS.year.id
        ? moment.tz(payload.value || 0, EARNINGS_DATA_TIMEZONE).format("MMM")
        : filterType === TIME_FILTER_OPTIONS.month.id
        ? getWeekLabel(payload.value)
        : moment
            .tz(payload.value || 0, EARNINGS_DATA_TIMEZONE)
            .format("MMM Do"),
    [filterType, payload.value],
  );
  return (
    <text
      x={x}
      y={y}
      dominantBaseline={"hanging"}
      textAnchor="middle"
      fill={isCurr ? "darker" : !isFuture ? "var(--gray01)" : "var(--gray02)"}
      className={getClasses(
        styles["custom-x-axis-tick"],
        isCurr && styles["custom-x-axis-tick--current"],
        isFuture && styles["custom-x-axis-tick--future"],
      )}
    >
      {label}
    </text>
  );
};

export default CustomXAxisTick;
